import {combine} from 'effector';

import {fetchWithdrawalDictionary, fetchWithdrawalGrid} from 'api/documents/documents';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {WithdrawalDictionary, WithdrawalGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';

const domain = rootDomain.createDomain('WithdrawalGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchWithdrawalListFx',
    handler: fetchWithdrawalGrid,
});

export const fetchDictionaryFx = domain.createEffect({
    name: 'fetchWithdrawalDictionaryFx',
    handler: fetchWithdrawalDictionary,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    Gate,
    tableStateChanged,
    stateReset,
} = createGridTableModel({domain, defaultSortings: {createdAt: true}});

export const data$ = domain.createStore<SimplePaginationContent<WithdrawalGridRawRow> | null>(null);
export const dictionary$ = domain.createStore<WithdrawalDictionary>({});

export const searchChanged = domain.createEvent<string>();
export const searchReset = domain.createEvent();
export const search$ = domain
    .createStore('')
    .on(searchChanged, (_, value) => value)
    .reset(searchReset);

export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const tableState$ = combine({
    data: data$,
    dictionary: dictionary$,
    pageNumber: pageNumber$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    isLoading: fetchDataFx.pending,
});
